import pug from 'javascripts/messages/templates/form.jst.pug';
window.JST = window.JST || {};
window.JST['messages/templates/form'] = pug;
